import React, { useMemo } from 'react';
import { styled } from '@mui/material';
import Box from "../Box";
import Typography from '../Typography';
import ListSelectionInput from '../ListSelectionInput';
const HeaderContainer = styled('div')(_ref => {
  let {
    theme
  } = _ref;
  return {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: theme.spacing(1)
  };
});
const TitleContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  flexGrow: 1,
  marginLeft: 1,
  marginRight: 1
}));
const ContentContainer = styled('div', {
  shouldForwardProp: prop => prop !== 'checkboxPadding'
})(_ref2 => {
  let {
    checkboxPadding,
    theme
  } = _ref2;
  return {
    marginLeft: checkboxPadding ? theme.spacing(6) : theme.spacing(0)
  };
});
const CardContainer = styled('div')(_ref3 => {
  let {
    theme
  } = _ref3;
  return {
    background: theme.palette.background.paper,
    padding: theme.spacing(2),
    borderRadius: 5,
    boxShadow: '0px 3px 4px -1px rgb(0 0 0 / 10%), 0px 2px 4px 0px rgb(0 0 0 / 2%), 0px 1px 3px 0px rgb(0 0 0 / 12%);'
  };
});
export function ListItemCard(_ref4) {
  let {
    renderTitleAdornment,
    renderContent,
    renderActions,
    selectable = false,
    selectableContentPadding = true,
    isSelected,
    onSelection,
    selectionType = 'multiple',
    node,
    title,
    getCheckboxAriaLabel,
    nodeContext = {}
  } = _ref4;
  const shouldRenderTitleAdornment = typeof renderTitleAdornment === 'function';
  const shouldRenderContent = typeof renderContent === 'function';
  const shouldRenderActions = typeof renderActions === 'function';
  const checkboxName = useMemo(() => {
    if (selectable && typeof getCheckboxAriaLabel === 'function') {
      return getCheckboxAriaLabel(node);
    }
    return '';
  }, [node, selectable, getCheckboxAriaLabel]);
  const TitleAdornment = useMemo(() => shouldRenderTitleAdornment ? renderTitleAdornment(node, nodeContext) : null, [node, shouldRenderTitleAdornment, renderTitleAdornment]);
  const Actions = useMemo(() => shouldRenderActions ? renderActions(node, nodeContext) : null, [node, shouldRenderActions, renderActions]);
  const Content = useMemo(() => shouldRenderContent ? renderContent(node, nodeContext) : null, [node, shouldRenderContent, renderContent]);
  return /*#__PURE__*/React.createElement(CardContainer, null, /*#__PURE__*/React.createElement(HeaderContainer, null, selectable && /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(ListSelectionInput, {
    selectionType: selectionType,
    selected: isSelected,
    ariaLabel: checkboxName,
    onSelection: () => typeof onSelection === 'function' && onSelection(node, !isSelected)
  })), /*#__PURE__*/React.createElement(TitleContainer, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    color: "primary"
  }, title), TitleAdornment), /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: "flex",
      textAlign: "right",
      justifyItems: "right"
    }
  }, Actions)), /*#__PURE__*/React.createElement(ContentContainer, {
    checkboxPadding: selectable && selectableContentPadding
  }, Content));
}
export default ListItemCard;